import { render, staticRenderFns } from "./TutorialCard.vue?vue&type=template&id=390dfa90&scoped=true"
import script from "./TutorialCard.vue?vue&type=script&lang=js"
export * from "./TutorialCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390dfa90",
  null
  
)

export default component.exports